import React from 'react'
import PropTypes from 'prop-types'

import BasePressIcon from './PressIcon.base'

const ParentsMagazine = ({ className, ...props }) => (
  <BasePressIcon className={className} onClick={() => props.onClick('parents_magazine')} box='0 0 225 75'>
    <path d="M40.05,37.99c0.78,0.2,1.82,0.33,2.73,0.33c7.74,0,10.87-3.78,10.87-11.45c0-8.26-1.3-11.45-8.33-11.45h-5.27V37.99
      L40.05,37.99L40.05,37.99z M24.63,58.88h5.27V15.41h-5.27v-1.17h23.23c11.39,0,16.73,4.23,16.73,12.24
      c0,7.87-7.68,13.02-17.51,13.02c-2.73,0-5.08-0.07-7.03-0.26v19.65h6.44v1.17H24.63V58.88L24.63,58.88z"/>
    <path d="M73.97,44.76l-5.14,0.52c-4.23,0.45-4.62,2.73-4.62,6.18c0,3.38,0.2,7.42,4.62,7.42c3.06,0,5.01-3.12,5.14-6.57V44.76
      L73.97,44.76L73.97,44.76z M81.73,60.76h-2.31c-2.42-0.31-4.37-1.65-5.38-4.03c-1.44,2.65-4.89,3.76-7.45,4.03H63.8
      c-4.47-0.42-8.58-2.78-8.58-7.87c0-6.77,6.44-8.33,12.36-8.79l6.38-0.52v-5.47c0-3.91-0.65-6.31-5.53-6.31
      c-2.21,0-5.99,0.52-5.92,1.95c0.07,1.11,3.32,0.91,3.32,4.03c0,2.28-1.5,3.9-3.97,3.9c-2.93,0-4.23-1.95-4.23-4.23
      c0-0.16,0.01-0.32,0.03-0.47l5.74-5.51c1.6-0.54,3.46-0.85,5.49-0.85c6.7,0,13.67,1.82,13.67,9.24v14.97c0,2.02,0.33,3.25,1.5,3.25
      c1.56,0,2.28-1.95,2.28-3.64h1.17C87.5,57.92,85.28,60.33,81.73,60.76L81.73,60.76z"/>
    <path d="M85.73,57.05V32.59h-4.49v-1.17h4.49c2.67,0,7.48,0,8.85-1.69v6.64h0.13c1.24-3.25,4.43-6.12,8.59-6.12
      c3.06,0,5.14,1.89,5.14,5.01c0,2.47-1.82,4.75-4.95,4.75c-2.54,0-4.43-1.69-4.43-4.23c0-1.63,0.45-2.67,1.56-3.84h-0.26
      c-4.1,1.82-5.66,5.34-5.66,10.35v16.59h5.99v1.17H84.16L85.73,57.05L85.73,57.05z"/>
    <path d="M122.73,43.13v-5.6c0-3.58-0.98-5.73-4.1-5.73c-2.21,0-4.1,1.37-4.1,5.73v5.6H122.73L122.73,43.13L122.73,43.13z
       M120.88,60.76h-3.12c-7.55-0.71-13-6.76-13-14.7c0-8.79,6.64-15.42,14.32-15.42c6.83-0.13,13.34,6.64,13.41,13.67h-17.96v5.47
      c0,4.43,0.65,9.5,6.7,9.5c5.08,0,8.85-3.78,10.28-9.83h1.17C131.35,55.44,127.82,60.14,120.88,60.76L120.88,60.76z"/>
    <path d="M129.65,58.88h4.49V32.59h-4.49v-1.17h4.62c2.67,0,7.48,0,8.85-1.69v6.96h0.13c1.76-3.77,6.05-6.05,10.41-6.05
      c6.18,0,9.18,3.06,9.18,10.09v18.16h4.49v1.17h-17.18v-1.17h3.71V38.32c0-4.56-1.95-5.34-3.84-5.34c-3.64,0-6.9,4.75-6.9,8.07
      v17.83h3.84v1.17h-17.31V58.88L129.65,58.88z"/>
    <path d="M178.8,58.75c-1.35,1.14-2.94,1.8-4.87,2.01h-2.25c-2.25-0.33-6.29-1.97-6.29-7.35V32.59h-3.45v-1.17
      c6.57,0,11.26-7.09,11.26-13.99h1.17v13.99h5.99v1.17h-5.99v22.13c0,2.15,0.85,3.38,2.54,3.38c0.74,0,1.36-0.32,1.89-0.78
      L178.8,58.75L178.8,58.75z"/>
    <path d="M178.77,49.9h1.17c1.17,4.75,5.21,9.76,10.15,9.76c3.51,0,6.38-2.15,6.38-5.59c0-2.99-1.95-3.45-6.64-4.03
      c-4.95-0.59-11.32-1.3-11.32-9.7c0-4.16,3.19-9.7,9.7-9.7c2.99,0,4.69,1.43,6.77,1.43c1.24,0,2.02-0.65,2.02-1.43h0.98l0.39,9.24
      h-1.04c-1.63-4.23-4.23-8.07-9.11-8.07c-3.51,0-6.18,1.82-6.18,4.88c0,2.86,2.28,3.45,5.92,3.97c6.96,0.98,12.43,1.56,12.43,9.5
      c0,4.98-3.68,9.96-9.2,10.6h-2.54c-2.83-0.3-4.55-1.49-6.03-1.49c-1.27,0-2.29,0.5-2.64,1.49h-1.2V49.9L178.77,49.9z"/>
  </BasePressIcon>
)

ParentsMagazine.propTypes = {
  className: PropTypes.string
}

export default ParentsMagazine



// WEBPACK FOOTER //
// ./src/core/icons/press/ParentsMagazine.base.js